import styled from "styled-components";
import WhyChooseUsCard from "./WhyChooseUsCard";
import { useScroll, motion } from "framer-motion";
import { useContext, useRef } from "react";
import TestimonialCard from "./TestimonialCard";
import LoggedOutSectionTitle from "./LoggedOutSectionTitle";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";
import StylishUnderline from "../../../helperComponents/StylishUnderline";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  margin-top: 100px;

  @media (max-width: 900px) {
    gap: 20px;
  }
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

const Description = styled.div`
  text-align: center;
  opacity: 0.7;
  color: var(--element);
  font-weight: 600;
`;

const List = styled.div`
  display: grid;
  width: auto;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

const Underline = styled.div`
  height: 5px;
  border-radius: 5px;
  width: 100%;
  background-color: var(--accentColor);
`;

export default function Testimonials({ containerRef }) {
  const { isMobile } = useContext(Context);

  const { t } = useTranslation();
  const targetRef = useRef(null);

  const animation = useScroll({
    container: containerRef,
    target: targetRef,
    offset: ["0 1", "0.7 1"],
  });

  const animationCards = useScroll({
    container: containerRef,
    target: targetRef,
    offset: ["0.3 1", "0.7 1"],
  });

  return (
    <Container ref={targetRef} id="testimonials">
      <motion.div style={{ scale: isMobile ? 1 : animation.scrollYProgress }}>
        <Top>
          <LoggedOutSectionTitle>
            {t("testimonialsSectionTitle")}
          </LoggedOutSectionTitle>
          <StylishUnderline />
          <Description>{t("testimonialsSectionDesc")}</Description>
        </Top>
      </motion.div>

      <motion.div
        style={{ scale: isMobile ? 1 : animationCards.scrollYProgress }}
      >
        <List>
          <TestimonialCard name="Aïcha K., Abidjan">
            Après une blessure au genou, j’avais peur de reprendre le sport.
            Le parcours de récupération mêlant kinésithérapie, cryothérapie et
            renforcement progressif m’a permis de retrouver confiance et
            mobilité sans me sentir brusquée.
          </TestimonialCard>
          <TestimonialCard name="Yao M., Athlète ivoirien">
            J’utilise Wellness Care Center après chaque compétition pour la
            cryo corps entier, les bains de glace et la pressothérapie. Ma
            récupération est plus rapide, je dors mieux et je me sens prêt plus
            vite pour les entraînements.
          </TestimonialCard>
          <TestimonialCard name="Claire L., Paris">
            En déplacement régulier à Abidjan, j’ai trouvé ici un vrai espace de
            remise en forme globale : Visbody 3D scan, suivi nutritionnel et
            séances EMS m’aident à garder un équilibre malgré un rythme de vie
            chargé.
          </TestimonialCard>
          <TestimonialCard name="Mohamed B., Abidjan">
            Je cherchais un lieu où l’on m’écoute vraiment. Entre les
            consultations avec l’ostéopathe, le naturopathe et les séances de
            sauna infrarouge, j’ai enfin l’impression de prendre soin de ma
            santé sur le long terme, pas seulement de “faire du sport”.
          </TestimonialCard>
        </List>
      </motion.div>
    </Container>
  );
}
